// src/App.js
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";

// Pages Auth
import Authentification from "./pages/auth/authentification";
import Home from "./pages/home/Home";
import Profile from "./pages/auth/Profile";
import ChangePassword from "./pages/auth/ChangePassword";
import GestionComptes from "./pages/auth/GestionComptes";
import AjouterCompte from "./pages/auth/AjouterCompte";
import ModifierCompte from "./pages/auth/Modifiercompte";
import DetailsCompte from "./pages/auth/DetailsCompte";
import MotPassOublier from "./pages/auth/MotPassOublier";
import VerifierCode from "./pages/auth/verifiercode";
import NouveauMDP from "./pages/auth/nouveauxMDP";

// Pages Info Centre
import Formations from "./pages/infoCentre/Formations";
import Categories from "./pages/infoCentre/Categories";
import Formateurs from "./pages/infoCentre/Formateurs";
import SessionFormation from "./pages/infoCentre/session_formation";

// Pages CRM
import Prospects from "./pages/crm/prospects";
import Etudiants from "./pages/crm/Etudiants";
import Diplomes from "./pages/crm/diplomes";
import MarketingMail from "./pages/crm/MarketingMail";

// Pages Lab Manager
import Salles from "./pages/lab/Salles";
import Planning from "./pages/lab/Planning";
import Presences from "./pages/lab/Presences";
import Notes from "./pages/lab/Notes";
import Messagerie from "./pages/lab/Messagerie";

// ✅ NOUVEAU - Dashboard Scoring IA
import DashboardScoringIA from "./pages/bi/DashboardScoringIA";

// Composants
import PrivateRoute from "./components/PrivateRoute";

const COMMERCIAL = ["super_admin", "admin", "agent_marketing"];

function App() {
  return (
    <Router>
      <AuthProvider>
        <Routes>
          {/* Connexion */}
          <Route path="/" element={<Authentification />} />

          {/* Auth */}
          {/* L'accueil, ce sont les relances commerciales : formateurs et étudiants
              arrivent sur leur planning. */}
          <Route path="/home"            element={<PrivateRoute roles={COMMERCIAL}><Home /></PrivateRoute>} />
          <Route path="/mon-profil"      element={<PrivateRoute><Profile /></PrivateRoute>} />
          <Route path="/change-password" element={<PrivateRoute><ChangePassword /></PrivateRoute>} />

          {/* Gestion des comptes */}
          <Route path="/gestion-comptes"  element={<PrivateRoute><GestionComptes /></PrivateRoute>} />
          <Route path="/ajouter-compte"   element={<PrivateRoute><AjouterCompte /></PrivateRoute>} />
          <Route path="/modifier-compte"  element={<PrivateRoute><ModifierCompte /></PrivateRoute>} />
          <Route path="/details-compte"   element={<PrivateRoute><DetailsCompte /></PrivateRoute>} />

          {/* Info Centre */}
          {/* Informations du centre : l'équipe seulement, ni étudiants ni formateurs
              (demande de l'équipe). Ils sont renvoyés vers leur planning. */}
          <Route path="/formations" element={<PrivateRoute roles={COMMERCIAL}><Formations /></PrivateRoute>} />
          <Route path="/categories" element={<PrivateRoute roles={COMMERCIAL}><Categories /></PrivateRoute>} />
          <Route path="/formateurs" element={<PrivateRoute roles={COMMERCIAL}><Formateurs /></PrivateRoute>} />
          <Route path="/session-formations" element={<PrivateRoute roles={COMMERCIAL}><SessionFormation /></PrivateRoute>} />

          {/* CRM */}
          <Route path="/prospects" element={<PrivateRoute><Prospects /></PrivateRoute>} />
          <Route path="/etudiants" element={<PrivateRoute><Etudiants /></PrivateRoute>} />
          <Route path="/diplomes"  element={<PrivateRoute><Diplomes /></PrivateRoute>} />
          <Route path="/marketing-mail" element={<PrivateRoute><MarketingMail /></PrivateRoute>} />

          {/* Lab Manager */}
          <Route path="/salles"     element={<PrivateRoute roles={COMMERCIAL}><Salles /></PrivateRoute>} />
          <Route path="/planning"   element={<PrivateRoute><Planning /></PrivateRoute>} />
          <Route path="/presences"  element={<PrivateRoute><Presences /></PrivateRoute>} />
          <Route path="/notes"      element={<PrivateRoute><Notes /></PrivateRoute>} />
          <Route path="/messagerie" element={<PrivateRoute><Messagerie /></PrivateRoute>} />

          {/* ✅ NOUVEAU - Dashboard Scoring IA */}
          <Route path="/dashboard-scoring-ia" element={<PrivateRoute><DashboardScoringIA /></PrivateRoute>} />

          {/* Mot de passe oublié */}
          <Route path="/mot-de-passe-oublie" element={<MotPassOublier />} />
          <Route path="/verify-code"         element={<VerifierCode />} />
          <Route path="/reset-password"      element={<NouveauMDP />} />
        </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App;